import { IDatePickerData } from './types'

export const LNR_FORM_COMPLETENESS_FIELDS = [
  'ApprovalStatus',
  'ApprovalStatusReasons',
  'DDQSent',
  'DDQCompleted',
  'SentToCompliance',
  'ContactId',
]

export interface IDatePickerGroup {
  title: string
  pickers: IDatePickerData[]
}

export const DATE_PICKER_GROUPS: IDatePickerGroup[] = [
  {
    title: 'DDQ',
    pickers: [
      { field: 'DDQSent', label: 'Sent to partner' },
      { field: 'DDQResponded', label: 'Responded' },
      { field: 'DDQCompleted', label: 'Completed' },
      { field: 'DDQRejected', label: 'Rejected' },
    ],
  },
  {
    title: 'Investigation',
    pickers: [
      { field: 'InvestigStartDate', label: 'Start date' },
      { field: 'InvestigEndDate', label: 'End date' },
    ],
  },
  {
    title: 'Compliance',
    pickers: [{ field: 'SentToCompliance', label: 'Sent date' }],
  },
]
